import { OrderVDriveCancellationFeeResponse } from '../types';
import { vDriveDeliveryStatus } from '../types/api/wallet.types';
import {
  SimpleVDriveDeliveryEntity,
  VDriveDeliveryEntity,
  VDriveGetQuoteHistoryResponse,
  VDriveGetRecordingResponse,
} from '../types/deliveries.types';
import {
  Coordinates,
  DateRangeParams,
  PaginationParams,
  ReportExportResponse,
  ResponseType,
} from '../types/shared.types';
import { api } from './api';

export type CreateDeliveriesReportExportBody = Partial<
  DateRangeParams<{
    locationIds?: Array<number>;
    brandIds?: Array<number>;
    status?: vDriveDeliveryStatus;
    query?: string;
    includePhysicalLocationsOnly?: boolean;
  }>
>;

export const createDeliveriesReportExport = (
  params: CreateDeliveriesReportExportBody
) =>
  api.post<ResponseType<ReportExportResponse>>(
    `/v1/deliveries/report/export`,
    undefined,
    { params }
  );

export const getDeliveriesReportExport = (id: number | string) =>
  api.get<ResponseType<ReportExportResponse>>(
    `/v1/deliveries/report/export/${id}`
  );

export const findAllDeliveries = (
  params: PaginationParams<{
    brandIds?: number[] | null;
    locationIds?: number[] | null;
    from?: string | null;
    to?: string | null;
    query?: string | null;
    status?: vDriveDeliveryStatus | null;
  }>
) =>
  api.get<ResponseType<SimpleVDriveDeliveryEntity[]>>(`/v1/deliveries`, {
    params,
  });

export const migrateFD = () => api.put<ResponseType<null>>(`/v1/deliveries`);

export const getDriverLocationByOrderId = (id: number | string) =>
  api.get<ResponseType<Coordinates>>(`/v1/deliveries/${id}/driver`);

export const requestRefund = (id: string | number) =>
  api.get<ResponseType<string>>(`/v1/deliveries/${id}/refund`);

export const findOrderById = (id: string | number) =>
  api.get<ResponseType<VDriveDeliveryEntity>>(`/v1/deliveries/${id}`);

export const cancelVDriveOrder = (
  id: string | number,
  reason?: string | null
) =>
  api.post<ResponseType<VDriveDeliveryEntity>>(`/v1/deliveries/${id}/cancel`, {
    reason,
  });

export const getCancelVDriveDeliveryFee = (id: string | number) =>
  api.post<ResponseType<OrderVDriveCancellationFeeResponse>>(
    `/v1/deliveries/${id}/cancellation-fee`
  );

export const updateInternalNotes = (id: string | number, note: string) =>
  api.post<ResponseType<VDriveDeliveryEntity>>(
    `/v1/deliveries/${id}/internal-note`,
    {
      note,
    }
  );

export const assignDeliveryToAuthenticatedUser = (id: string | number) =>
  api.post<ResponseType<VDriveDeliveryEntity>>(
    `/v1/deliveries/${id}/assign-dispatcher`
  );

export const markDeliveryAsReady = (id: string | number) =>
  api.post<ResponseType<VDriveDeliveryEntity>>(
    `/v1/deliveries/${id}/mark-as-ready`
  );

export const getInterceptorCall = (id: string | number) =>
  api.get<ResponseType<VDriveGetRecordingResponse>>(
    `/v1/deliveries/${id}/call-recording`
  );

export const getDeliveriesAssignHistory = (id: string | number) =>
  api.get<ResponseType<VDriveGetQuoteHistoryResponse[]>>(
    `/v1/deliveries/${id}/quotes-history`
  );
